module.exports = __webpack_public_path__ + "img/img-9.e80cb350.svg";